(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dynamic-image-lazy-load"] && !Shopify.designMode) return;
  try {
    (function () {
    if (typeof LazyLoad === 'undefined') return;

    function getResponsiveImageUrl(node) {
      if (node.dataset.responsiveReplace !== 'true') return;

      var mobileImg = node.dataset.bgMobile;
      var tabletImg = node.dataset.bgTablet;
      var desktopImg = node.dataset.bgDesktop;
      var imageObjectImg = node.dataset.bgImageObject;
      var tabletThreshold = parseInt(node.dataset.tabletThreshold) || 750;
      var desktopThreshold = parseInt(node.dataset.desktopThreshold) || 1920;

      if (window.innerWidth >= desktopThreshold && desktopImg) {
        return desktopImg;
      }
      if (window.innerWidth >= tabletThreshold && tabletImg) {
        return tabletImg;
      }
      return mobileImg || imageObjectImg || undefined;
    }

    var blurredImgs = document.querySelectorAll('.blurred-img');
    if (!blurredImgs.length) return;

    blurredImgs.forEach(function (div) {
      var img = div.querySelector('img');
      if (!img) return;
      var resImg = getResponsiveImageUrl(div);
      if (resImg) {
        img.src = resImg;
      }
    });

    new LazyLoad({
      callback_loaded: function (el) {
        el.classList.add('loaded');
        var wrapper = el.closest('.blurred-img');
        if (wrapper) wrapper.classList.add('loaded');
      },
      callback_error: function (el) {
        var wrapper = el.closest('.blurred-img');
        if (wrapper) wrapper.classList.add('error');
      },
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
